// Get the payment status of the user and check to see if they have
// paid with cash or if their wallet balance is sufficient to cover their
// order.
export default function getPaymentStatus(usersWalletInfo, userId, grandTotal) {
  const wallet = usersWalletInfo[userId];
  if (!wallet) return ""; // show nothing if wallet doesn't exist
  // If the user is paying with Cash.
  if (wallet.paymentMethod === "cash") return "Paying Cash";
  // If the user has more in their wallet than what they owe.
  if (wallet.Total >= grandTotal) return "Account Balanced";
  // If there wallet doesn't have enough money in it to cover the order
  // and they are paying with Credits.
  return "Insufficient Funds";
}
